"use client"

import { Skeleton } from "@/components/ui/skeleton"

const SubFeaturePostsSkeleton = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 w-full">
      {Array.from({ length: 3 }).map((_, idx) => (
        <div key={idx} className="flex flex-col gap-2">
          <Skeleton className="h-[173px] w-full rounded" />
          <Skeleton className="h-5 w-full rounded" />
          <Skeleton className="h-4 w-24 rounded" />
        </div>
      ))}
    </div>
  )
}

export default SubFeaturePostsSkeleton
